import { useContext, useEffect, useRef, useState } from 'react';

import pop_sfx from '@/assets/sound_effects/pop.mp3';
import '@/style/AnimatedTicker.css';
import { GameContext, ViewContext } from '@/state/contexts';
import { logg } from '@/util/logg';
import { getPlayerStateWithId } from '@/util/player';

import NewsCard from './card/NewsCard';
import SeasonalCard from './card/SeasonalCard';
import SummitCard from './card/SummitCard';

const TickerElement = ({ tickerItem, cardId, cardType, color }) => {
	function displayCardByType() {
		if (cardType === 'seasonal') {
			return <SeasonalCard cardId={cardId} width={0} height={0} />;
		} else if (cardType === 'news') {
			return <NewsCard cardId={cardId} width={0} height={0} />;
		} else if (cardType === 'summit') {
			return <SummitCard cardId={cardId} width={0} height={0} />;
		}
	}

	function getColor(color) {
		if (color === 'yellow') {
			return '#f6de9a';
		} else if (color === 'blue') {
			return '#15bedb';
		} else if (color === 'red') {
			return '#efa1ae';
		} else if (color === 'green') {
			return '#556341';
		} else if (color === 'fail') {
			return '#fb2d01';
		}

		return 'white';
	}

	if (cardId === -1) {
		return (
			<p className="tickerItem" style={{ color: getColor(color) }}>
				{tickerItem}
			</p>
		);
	}

	return (
		<div className="tickerCardImgHover">
			{cardType === 'news' ? (
				<p className="tickerItem">News Card Flipped</p>
			) : (
				<p className="tickerItem" style={{ color: getColor(color), whiteSpace: 'pre-wrap' }}>
					{tickerItem}
				</p>
			)}
			<div className="tickerImg">{displayCardByType()}</div>
		</div>
	);
};

function AnimatedTickerToast() {
	const audioRef: any = useRef(null);
	const { gameStatus, lastTickerUpdate, playerStateArray }: any =
		useContext(GameContext);

	const {
		currentTickerIndex,
		setCurrentTickerIndex,
		tickerActual,
		setTickerActual,
		currentTickerTimer,
		setCurrentTickerTimer,
	}: any = useContext(ViewContext);

	const { tickerTimeoutSeconds }: any = useContext(ViewContext);
	const [showMessage, setShowMessage] = useState(false);

	// ✅ Reset index and start showing when new ticker data comes in
	useEffect(() => {
		logg('lastTickerUpdate');
		logg(lastTickerUpdate);
		if (
			lastTickerUpdate != null &&
			Array.isArray(lastTickerUpdate) &&
			lastTickerUpdate.length > 0
		) {
			setCurrentTickerIndex(0);
			setShowMessage(true);
			setTickerActual([...lastTickerUpdate].reverse() as any);
		}
	}, [lastTickerUpdate]);

	useEffect(() => {
		logg('tickerActual');
		logg(tickerActual);

		if (!tickerActual || tickerActual.length === 0) return;
		if (currentTickerIndex >= tickerActual.length) return;

		setShowMessage(true);
		// play tick here
		// const audioSrc = "/assets/sound_effects/clock_tick_1.mp3";
		const audioSrc = pop_sfx;

		const audio = new Audio(audioSrc);
		audio.loop = false;
		audio.volume = 0.33; // volume;
		audio.play();
		audioRef.current = audio;

		logg('trying to display ANIMATED TICKER MESSAGES');

		const timer = setTimeout(() => {
			setShowMessage(false);
			setTimeout(() => {
				setCurrentTickerIndex((prev) => prev + 1);
			}, 100);
		}, tickerTimeoutSeconds * 1000);

		setCurrentTickerTimer(timer);

		return () => clearTimeout(timer);
	}, [currentTickerIndex, tickerActual]);

	if (
		!showMessage ||
		!tickerActual[currentTickerIndex] ||
		gameStatus === 1 ||
		gameStatus === 2
	) {
		clearTimeout(currentTickerTimer);
		setCurrentTickerIndex(tickerActual.length);
		return null;
	}

	function getCardIdForTickerItem(tickerItem) {
		let cardId = -1;
		let cardType = '';
		let color = 'white';
		const tickerArr = tickerItem.split(' ');

		// logg("tickerArr");
		// logg(tickerArr);

		if (tickerArr[0] === 'Player') {
			const pId = parseInt(tickerArr[1]);
			if (pId === 0 || pId === 1 || pId === 2 || pId === 3) {
				const playerState = getPlayerStateWithId(playerStateArray, pId);

				if (playerState && playerState.color) {
					color = playerState?.color;
				}
			}
		}

		if (tickerArr[0] === 'Player' && tickerArr[2] === 'won') {
			cardId = parseInt(tickerArr[tickerArr.length - 1]);
			cardType = 'seasonal';
		}

		for (let i = 0; i < tickerArr.length; i++) {
			if (tickerArr[i] === 'failed') {
				color = 'fail';
			}
			if (tickerArr[i] === 'playCard') {
				cardId = parseInt(tickerArr[i + 1]);
				cardType = 'seasonal';
				break;
			} else if (tickerArr[i] === 'playEquipmentById') {
				cardId = parseInt(tickerArr[i + 1]);
				cardType = 'seasonal';
				break;
			} else if (tickerArr[i] === 'playSummitCard') {
				cardId = parseInt(tickerArr[i + 1]);
				cardType = 'summit';
				break;
			} else if (tickerArr[i] === 'News' && tickerArr[i + 1] === 'card') {
				let cardTempId = tickerArr[i + 2];
				cardId = parseInt(
					cardTempId.substring(0, cardTempId.length - 1)
				);
				cardType = 'news';
			}
		}

		return { cardId, cardType, color };
	}

	function processTickerForCards(tickerItem: string) {
		const { cardId, cardType, color } = getCardIdForTickerItem(tickerItem);
		logg('processTickerForCard', cardId, cardType, color);

		if (cardId > -1) {
			return (
				<TickerElement
					tickerItem={tickerItem}
					cardId={cardId}
					cardType={cardType}
					color={color}
				/>
			);
		}
		return tickerItem;
	}

	return (
		<div className="message-popup">
			{processTickerForCards(tickerActual[currentTickerIndex])}
		</div>
	);
}

export default AnimatedTickerToast;
